import {t} from 'i18next'
import React from 'react'
import {Observation} from '../../../../model/observation'
import {Competence} from '../../../../services/competenceService'


/**
 * We do have the sub-competence db id
 * but want to display the label of the competence e.g. "professional competence/Fachkompetenz"
 * @param {Observation} observation
 * @param competenceTree
 * @returns {JSX.Element}
 */
export const CompetenceBody = (observation: Observation, competenceTree: Competence[]): JSX.Element => {

	if (!competenceTree) {
		return <></>
	}
	for (let i = 0; i < competenceTree.length; i++) {

		const subCompetences = competenceTree[i].children
		if (subCompetences) {
			for (let j = 0; j < subCompetences.length; j++) {
				const dbId = subCompetences[j].dbId
				if (observation.id_sub_competence === dbId) {
					return <>{t<string>(competenceTree[i].label)}</>
				}
			}
		}
	}

	return <span/>
}

/**
 *
 * @param observation
 * @param competenceTree
 */
export const SubCompetenceBody = (observation: Observation, competenceTree: Competence[]): JSX.Element => {

	if (!competenceTree) {
		return <></>
	}
	for (let i = 0; i < competenceTree.length; i++) {

		const subCompetences = competenceTree[i].children
		if (subCompetences) {
			for (let j = 0; j < subCompetences.length; j++) {
				const dbId = subCompetences[j].dbId
				if (observation.id_sub_competence === dbId) {

					if (!observation.id_competence_detail) {
						return <>{t<string>(subCompetences[j].label)}</>
					}
					const detailCompetences = subCompetences[j].children
					if (detailCompetences) {
						for (let k = 0; k < detailCompetences.length; k++) {
							if (observation.id_competence_detail === detailCompetences[k].dbId) {
								return (<span>{t<string>(subCompetences[j].label)} <br/>
									<span className={'secondary-text small-text'}>
                                            ({t<string>(detailCompetences[k].label)})
									</span>
								</span>)
							}
						}
					}

				}
			}
		}
	}
	return <span/>
}